<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑     永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2023-07-05 11:10:38
 * @LastEditTime: 2026-06-22 17:36:55
 * @Description: 通用表单附件
 * @FilePath: \ProjectTree_vue2\ConcreteCloud_Web\src\components\popUpForm\annex\index.vue
 -->

<template>
    <div id="annexData">
        <div class="plannedSpeed">
            <el-progress :percentage="progressPercent" status="success" :show-text="false" v-if="isProgress"></el-progress>
        </div>
        <el-row>
            <el-col :span="20">
                <div class="breadcrumb">
                    <a @click="backTop()">全部资料</a>
                    <template v-for="(item, index) in fileHierarchy">
                        <span :key="index" @click="returnDirectory(item.id, index)"><i class="el-icon-arrow-right"></i>{{ item.data }}</span>
                    </template>
                </div>
            </el-col>
            <el-col :span="4" class="fileBtn">
                <button title="上传" v-if="!isRead" @click.stop>
                    <el-upload class="uploadfile" action="" :http-request="uploadFileMethod" :show-file-list="false" multiple>
                        <i class="iconfont iconshangchuan"></i>
                    </el-upload>
                </button>
                <button class="iconfont icontianjia" v-if="!isRead" @click="isAdd = true"></button>
                <!-- <button class="iconfont icon-xiazai1"></button> -->
            </el-col>
        </el-row>
        <div id="Attachment" class="Annex">
            <div class="AnnexInfo" id="AnnexInfoContainer" options="Setting">
                <table>
                    <thead v-if="isAdd">
                        <tr class="tebleFome">
                            <th style="width: 5%;">
                                <svg class="iconwenjianjia1" aria-hidden="true">
                                    <use xlink:href="#iconwenjianjia1"></use>
                                </svg>
                            </th>
                            <td colspan="5">
                                <input type="text" v-model="newFile.group_name" class="form-control" placeholder="请输入文件夹名称">
                                <input type="text" v-model="newFile.FileDescription" class="form-control" placeholder="请输入描述">
                                <button class="el-icon-check" title="确认添加" @click="confirmAdd()"></button>
                                <button class="el-icon-close" title="取消添加" @click="isAdd = false"></button>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="(fileData || []).length > 0">
                            <tr v-for="(item, index) in fileData" :key="index" @click="seeFolderFile(item)">
                                <th style="width: 5%;">
                                    <svg v-if="item.FileType == 1" class="iconwenjianjia1" aria-hidden="true">
                                        <use xlink:href="#iconwenjianjia1"></use>
                                    </svg>
                                    <svg v-if="item.FileType == 0" class="iconwenjian" aria-hidden="true">
                                        <use xlink:href="#iconwenjian"></use>
                                    </svg>
                                </th>
                                <td style="width: 34%;">
                                    <span ref="content" class="fileName" :title="item.FileName" @click.stop @blur="preservationName($event, index, item)">
                                        {{ item.FileName }}
                                    </span>
                                </td>
                                <td style="width: 6%;">
                                    <span v-if="item.FileType == 0">
                                        {{ bytesToSize(item.FileSize) }}
                                    </span>
                                </td>
                                <td style="width: 22%;" class="btns">
                                    <button class="iconfont iconbianjishuru" title="重命名" v-if="!isRead" @click.stop="editFileClick(index)"></button>
                                    <button v-if="item.FileType == 1 && !isRead" title="上传" @click.stop="uploadClick(item)">
                                        <el-upload class="uploadfile" action="" :http-request="uploadFileMethod" :show-file-list="false" multiple>
                                            <i class="iconfont iconshangchuan"></i>
                                        </el-upload>
                                    </button>
                                    <button v-if="item.FileType == 0 && !isRead" class="iconfont iconxiazai1" title="下载" @click.stop="download(item)"></button>
                                    <button class="iconfont iconicon_yulan" title="预览" @click.stop="viewFileClick(item)"></button>
                                    <button v-if="item.FileType == 0 && !isRead" class="iconfont iconshanchu" title="删除文件" @click.stop="deleteFileClick(index, item)"></button>
                                    <button v-if="item.FileType == 1 && !isRead" class="iconfont iconshanchu" title="删除文件夹" @click.stop="deleteFileClick(index, item)"></button>
                                </td>
                                <td style="width: 21%;" :title="item.describe">
                                    {{ item.FileDescription }}
                                </td>
                                <td>{{ item.modified }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr class="noeAnnexData">
                                <td colspan="6">
                                    <p></p>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import '@/styles/components/formAnnex/annexStyle.styl';
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
export default {
    // 附件资料
    name: 'annex',
    components: {},
    mixins: [mixin_fileUpload],
    props: {
        formId: {
            type: [Array, Object, String, Number],
        },
        formData: {
            type: [Array, Object, String ],
        },
        isRead: {
            type: [Boolean, Object, String ],
            default: false,
        },
    },
    data() {
        return {
            // 附件面包屑导航数据
            fileHierarchy: [],
            // 附件数据
            fileData: [],
            // 新增文件夹绑定数据
            newFile: {
                group_name: '',
                FileDescription: '',
            },
            // 新增文件夹栏状态
            isAdd: false,
            // 文件夹id
            folderID: '',
            // 文件上传进度条状态
            isProgress: false,
            // 文件上传进度
            progressPercent: 0,
        };
    },
    watch: {
        formId: {
            async handler() {
                this.fileData = await this.gitAnnexDataRequest(this.formId);
            },
            immediate: true,
        },
    },
    async created() {
        console.log(this.isRead);
    },
    methods: {
        // 根据id过滤附件数据
        initFileData(newVal, val, type) {
            const initFileData = [];
            if (newVal && newVal !== null) {
                newVal.forEach(item => {
                    if (item.ParentID === val) {
                        if (type === 'FileID' && item.FileType !== '1') {
                            initFileData.push(item.FileID);
                        } else {
                            initFileData.push(item);
                        }
                    }
                });
            }
            return initFileData;
        },
        //   重命名
        editFileClick(index) {
            this.$refs.content[index].contentEditable = true;
            this.$refs.content[index].focus();
        },
        //   失焦确定重命名
        async preservationName(event, index, item) {
            this.$refs.content[index].contentEditable = false;
            const res = await this.preservationNameRequest(item.Id, event.target.innerText);
            if (res) {
                this.$message({ message: '更改成功！', type: 'success', showClose: true });
            }
        },
        // 文件下载
        download(data) {
            const downloadUrl = `${this.FILE.FILE_BASE_URL()}file-manage/${data.Id}/download`;
            this.$imagesDownload(downloadUrl, data.FileName);
        },
        // 预览
        async viewFileClick(data) {
            const picturePreviewList = [];
            if (data.FileType === '0' || data.FileType === 0) {
                picturePreviewList.push(data.Id);
            } else if (data.FileType === '1' || data.FileType === 1) {
                const res = await this.gitAnnexDataRequest(this.formId, data.Id);
                if ((res || []).length > 0) {
                    res.forEach(item => { picturePreviewList.push(item.Id); });
                } else {
                    this.$message({ message: '该文件夹下没有文件！', type: 'warning', showClose: true });
                }
            }
            if (picturePreviewList.length > 0) {
                this.$toast({
                    title: true,
                    text: '预览',
                    type: 'eject',
                    width: '79%',
                    height: '88%',
                    t_url: 'picturePreview/index',
                    extr: {
                        code: {
                            imgSrc: [],
                            picturePreview: picturePreviewList,
                        },
                    },
                    viewPosition: 'components',
                });
            }
        },
        //   删除
        async deleteFileClick(index, item) {
            const res = await this.deleteFileRequest(item.Id);
            if (res) {
                this.$message({ message: '删除成功！', type: 'success', showClose: true });
                this.fileData = await this.gitAnnexDataRequest(this.formId, item.DirectoryId);
            }
        },

        // 添加文件夹
        async confirmAdd() {
            if (this.newFile.group_name !== '') {
                const requestData = {
                    BusinessTypeCode: 'Flow',
                    DataId: this.formId,
                    DirectoryId: '',
                    FileName: this.newFile.group_name,
                    FileType: 1,
                    FileContent: '',
                };
                const res = await this.addFolderRequest(requestData);
                if (res) {
                    this.fileData.push(res);
                    this.newFile.group_name = '';
                    this.newFile.FileDescription = '';
                }
                this.isAdd = false;
            } else {
                this.$message({ message: '请填写文件名称！', type: 'warning', showClose: true });
            }
        },

        // 上传
        uploadClick(data) {
            this.folderID = data.Id;
        },

        // 上传文件
        async uploadFileMethod(param) {
            const tenantId = this.$takeTokenParameters('TenantId');
            const formData = new FormData();
            formData.append('FileType', 0);
            formData.append('BusinessTypeCode', 'Flow');
            formData.append('DataId', this.formId);
            formData.append('DirectoryId', this.folderID);
            formData.append('TenantId', tenantId);
            formData.append('File', param.file);
            const config = {
                onUploadProgress: progressEvent => {
                    this.progressPercent = 0;
                    this.isProgress = true;
                    this.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2));
                },
            };
            try {
                const res = await this.addFileRequest(formData, config);
                if (res) {
                    this.fileData = await this.gitAnnexDataRequest(this.formId, this.folderID);
                    this.videoFlag = false;
                    this.isProgress = false;
                }
            } catch (res) {
                console.log(res);
            }
        },

        // 查看文件夹附件
        async seeFolderFile(data) {
            if (data.FileType === '1' || data.FileType === 1) {
                this.folderID = data.Id;
                this.fileHierarchy.push({ data: data.FileName, id: data.Id });
                this.fileData = await this.gitAnnexDataRequest(this.formId, data.Id) || [];
            }
        },
        // 返回顶层
        async backTop() {
            this.folderID = '';
            this.fileData = await this.gitAnnexDataRequest(this.formId);
            this.fileHierarchy = [];
        },
        // 返回上级目录
        async returnDirectory(id, index) {
            this.fileData = await this.gitAnnexDataRequest(this.formId, id);
            this.fileHierarchy.splice(index + 1, this.fileHierarchy.length - index);
        },

        gitAnnexDataRequest(dataId, directory_id = '') {
            if ((dataId || '') === '') {
                return [];
            }
            return this.$axios.$get(`${this.FILE.FILE_BASE_URL()}file-manage/file_list/Flow/${dataId}?directory_id=${directory_id}`, { defEx: true });
        },

        preservationNameRequest(Id, name) {
            return this.$axios.$put(`${this.FILE.FILE_BASE_URL()}file-manage/${Id}/filename`, { FileName: name }, { defEx: true });
        },

        deleteFileRequest(Id) {
            return this.$axios.$delete(`${this.FILE.FILE_BASE_URL()}file-manage/${Id}`, {}, { defEx: true });
        },

        addFolderRequest(requestData) {
            return this.$axios.$post(`${this.FILE.FILE_BASE_URL()}file-manage/with-bytes?platformEnterprises=${this.platformEnterprises}`, requestData, { defEx: true });
        },

        addFileRequest(formData, config) {
            const tenantId = this.$takeTokenParameters('TenantId');
            return this.$axios.$post(`${this.FILE.FILE_BASE_URL()}file-manage?__tenant=${tenantId}`, formData, { defEx: true, ...config });
        },
    },
};
</script>

<style lang="stylus" scoped>
#annexData
    .Annex
        height calc(100% - 0.285)
        overflow-x hidden
        overflow-y auto
        .AnnexInfo
            height 100%
</style>
